import type { CmsResult } from '@nrdy-marketing-engine/nsp/src/fetch-nsp-data';
import React from 'react';

const FormContext = React.createContext<CmsResult['leadForm']>({});

export default FormContext;
